import { render, staticRenderFns } from "./ExpiredEmail.vue?vue&type=template&id=b49b7a72&scoped=true&"
import script from "./ExpiredEmail.vue?vue&type=script&lang=js&"
export * from "./ExpiredEmail.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredEmail.vue?vue&type=style&index=0&id=b49b7a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49b7a72",
  null
  
)

export default component.exports